import { QueryClient, useQuery } from "@tanstack/react-query";
import { GeneratedText } from "./types/GeneratedTexts";

export const REEPRISE_DETAILS_QUERY_KEY = "reeprise-details-query";

export function invalidateQuery(client: QueryClient, textId?: number): void {
  const fullKey = [REEPRISE_DETAILS_QUERY_KEY] as string[];
  if (textId !== undefined) fullKey.push(`${textId}`);
  client.invalidateQueries({ queryKey: fullKey });
}

export function useGeneratedTextDetails(generated_text_id: number) {
  const reepriseDetailsQuery = useQuery({
    queryKey: [REEPRISE_DETAILS_QUERY_KEY, `${generated_text_id}`],
    refetchInterval: (query) => {
      if (query.state.data && query.state.data.status === "PENDING") {
        return 500;
      }
      return false;
    },
    queryFn: async () => {
      const res = await fetch(
        `/api/reeprise/generated_texts/${generated_text_id}/`,
      );
      if (!res.ok) {
        throw new Error(
          `could not fetch /api/reeprise/generated_texts/${generated_text_id}`,
        );
      }
      return (await res.json()) as GeneratedText;
    },
  });

  return reepriseDetailsQuery;
}
